<script>
	export let color = ''
	let className = ''
	export { className as class }
</script>

<svg
	class="m-8 w-14 h-14 {color} {className}"
	fill="none"
	viewBox="0 0 58 58"
	xmlns="http://www.w3.org/2000/svg"
>
	<defs />
	<path stroke="#D9D9D9" stroke-linecap="round" stroke-width="2.9" d="M7.25 49.3h43.5" />
	<path
		fill="#fff"
		fill-rule="evenodd"
		d="M21.3 40.88a7.7 7.7 0 0015.4 0"
		clip-rule="evenodd"
	/>
	<path stroke="#333" stroke-width="1.45" d="M21.3 40.88a7.7 7.7 0 0015.4 0" />
	<path
		fill="#DEDEDE"
		fill-rule="evenodd"
		stroke="#333"
		stroke-linecap="square"
		stroke-width="1.45"
		d="M42.05 22.48a13.05 13.05 0 00-26.1 0v8.18l-6.53 4.35v5.87h39.15v-5.87l-6.52-4.35v-8.18 0z"
		clip-rule="evenodd"
	/>
	<path
		stroke="#9C9C9C"
		stroke-linecap="square"
		stroke-width="1.45"
		d="M44.23 12.32h2.9m-1.46-1.45v2.9-2.9zM7.97 25.38h2.9m-1.45-1.45v2.9-2.9z"
	/>
	<path
		stroke="#9C9C9C"
		stroke-linecap="square"
		stroke-width="2.9"
		d="M18.13 27.55v-5.16c0-5.45 4.02-10.06 9.42-10.79h.72"
	/>
	<path fill="#fff" d="M39.15 22.48a2.18 2.18 0 00-4.35 0v4.34a2.18 2.18 0 004.35 0v-4.34z" />
	<path
		stroke="#9C9C9C"
		stroke-linecap="square"
		stroke-width="1.45"
		d="M9.42 7.98h5.8m-2.9-2.9v5.8-5.8z"
	/>
</svg>